
import { defineComponent } from "vue";
import { getContainerById } from "@/service/container.service";
import { Container } from "@/types/container.type";
import SamplingPointListComponent from "@/components/samplingPoints/SamplingPointList.component.vue";
import ContainerInfoComponent from "@/components/containers/ContainerInfo.component.vue";
import StationTableListComponent from "@/components/stations/StationTableList.component.vue";

export default defineComponent({
  components: { SamplingPointListComponent, ContainerInfoComponent, StationTableListComponent },

  data() {
    return {
      container: {} as Container,
      id: Number(this.$route.params.containerid),
    };
  },
  async mounted() {
    this.container = await getContainerById(this.id);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
});
